import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { signInWithCustomToken } from 'firebase/auth';
import { auth } from '../../services/firebase';
import { trackLogin } from '../../utils';

export const useGoogleCallback = () => {
  const location = useLocation();

  useEffect(() => {
    const handleGoogleLoginCallback = async () => {
      const urlParams = new URLSearchParams(location.search);
      const token = urlParams.get('token');
      const email = urlParams.get('email');
      const name = urlParams.get('name');
      const given_name = urlParams.get('given_name');
      const family_name = urlParams.get('family_name');
      const picture = urlParams.get('picture');
      const locale = urlParams.get('locale');
      const email_verified = urlParams.get('email_verified') === 'true';
      const google_id = urlParams.get('google_id');
      const provider = urlParams.get('provider');
      const error = urlParams.get('error');

      if (error) {
        console.error('구글 로그인 에러:', error);
        alert(`구글 로그인 실패: ${decodeURIComponent(error)}`);
        // URL 파라미터 제거
        window.history.replaceState({}, document.title, window.location.pathname);
        return;
      }

      if (token) {
        try {
          // Firebase Custom Token으로 로그인
          const userCredential = await signInWithCustomToken(auth, token);
          
          if (userCredential.user) {
            // 사용자 정보를 Firestore에 저장
            if (email && name) {
              const { doc, setDoc, serverTimestamp } = await import('firebase/firestore');
              const { db } = await import('../../services/firebase');
              
              const userRef = doc(db, 'users', userCredential.user.uid);
              const userData = {
                uid: userCredential.user.uid,
                email: decodeURIComponent(email),
                displayName: decodeURIComponent(name),
                firstName: decodeURIComponent(given_name || ''),
                lastName: decodeURIComponent(family_name || ''),
                photoURL: decodeURIComponent(picture || ''),
                locale: decodeURIComponent(locale || ''),
                emailVerified: email_verified,
                googleId: google_id,
                provider: provider || 'google',
                createdAt: serverTimestamp(),
                lastLoginAt: serverTimestamp()
              };
              
              await setDoc(userRef, userData, { merge: true });
              console.log('구글 로그인 성공 및 사용자 정보 저장 완료:', userData);
            }
            
            console.log('구글 로그인 성공:', {
              uid: userCredential.user.uid,
              email: decodeURIComponent(email || ''),
              name: decodeURIComponent(name || ''),
              picture: decodeURIComponent(picture || '')
            });
            
            // URL 파라미터 제거
            window.history.replaceState({}, document.title, window.location.pathname);

            // Google Analytics 로그인 이벤트 추적
            try {
              trackLogin('google');
            } catch (error) {
              console.warn('Failed to track Google login:', error);
            }
          }
        } catch (error) {
          console.error('구글 로그인 처리 중 오류:', error);
          alert('구글 로그인 처리 중 오류가 발생했습니다: ' + error.message);
          // URL 파라미터 제거
          window.history.replaceState({}, document.title, window.location.pathname);
        }
      }
    };

    if (location.search) {
      handleGoogleLoginCallback();
    }
  }, [location.search]);
}; 